<script>
import MetisMenu from 'metismenujs/dist/metismenujs'

/* import { authComputed } from '@state/helpers' */
import { authProtectedRoutes } from '@routes'

/**
 * Application menu component
 */
export default {
  components: {},
  props: {
    mode: {
      type: String,
      default: 'vertical',
    }
  },
  data() {
    return {
      selectedItem:''
    }
  },
  computed: {
    menuItems(){
      // let user = this.user
      let role_modules = this.role_modules
      return authProtectedRoutes.filter(function(u) {
        if(u.name && u.name != 'dashboard'){
          if(role_modules.some(item => item.value == u.name.toLowerCase())){
            let subModules = u.children
            if(Array.isArray(subModules))
            for (var i = 0; i < subModules.length; i++) {
              if(subModules[i].name){
                if(role_modules.some(item => item.value == subModules[i].name.toLowerCase())){
                  subModules[i].hidden = false;
                }else {
                  subModules[i].hidden = true;
                }
              }
            }
            let adminModule = role_modules.find(element => element.value == "administration")
            let masterModule = role_modules.find(element => element.value == "master_file")
            if (u.name.toLowerCase() == 'administration') {
              return role_modules.some(item => item.parent == adminModule._id) ? true : false
            }
            else if ( u.name.toLowerCase() == 'master_file') {
              return role_modules.some(item => item.parent == masterModule._id) ? true : false
            }
            else{
              return u.hidden = true
            }
          }
        }
      })
    }
  },
  mounted: function() {
    // eslint-disable-next-line no-unused-vars
    var menuRef = null

    if (this.mode === 'horizontal') {
      menuRef = new MetisMenu('#side-menu').on('shown.metisMenu', function(
        event
      ) {
        window.addEventListener('click', function menuClick(e) {
          if (!event.target.contains(e.target)) {
            menuRef.hide(event.detail.shownElement)
            window.removeEventListener('click', menuClick)
          }
        })
      })
    } else {
      menuRef = new MetisMenu('#side-menu')
    }

    var links = document.getElementsByClassName('side-nav-link-ref')

    var matchingMenuItem = null
    // let menuItemEl = null
    for (var i = 0; i < links.length; i++) {
      if (window.location.pathname === links[i].pathname) {
        matchingMenuItem = links[i]
        break
      }
    }

    menuRef
    .on('shown.metisMenu', event => {
      this.selectedItem = event.detail.shownElement
    })/* 
    .on('hidden.metisMenu', event => {
      console.log(this.selectedItem,event);
    })
    .on('click', event => {
      console.log( event);

    }); */

    this.toggleActive(matchingMenuItem)
  },
  methods: {
    getChildren(children){
      return children.filter(function(u) {
        return u.hidden !== true
     })
    },
    toggleActive(matchingMenuItem){
      const activeClass = this.mode === 'horizontal' ? 'active' : 'active-link'
      const dropdownActiveClass =
        this.mode === 'horizontal' ? 'active' : 'mm-show'

      if (matchingMenuItem) {
        matchingMenuItem.classList.add('active')
        var parent = matchingMenuItem.parentElement

        /**
         * TODO: This is hard coded way of expading/activating parent menu dropdown and working till level 3.
         * We should come up with non hard coded approach
         */
        if (parent) {
          parent.classList.add(activeClass)
          const parent2 = parent.parentElement

          if (parent2) {
            parent2.classList.add(dropdownActiveClass)
          }
          const parent3 = parent2.parentElement
          if (parent3) {
            parent3.classList.add(activeClass)
            var childAnchor = parent3.querySelector('.has-dropdown')
            if (childAnchor) childAnchor.classList.add('active')
          }

          const parent4 = parent3.parentElement
          if (parent4) parent4.classList.add(dropdownActiveClass)
          const parent5 = parent4.parentElement
          if (parent5) parent5.classList.add(activeClass)
        }
      }
    },
    hasItems(item) {
      return item && !item.leaf && item.children !== undefined
        ? item.children.length > 0
        : false
    },
  },
}
</script>

<template>
  <!--- Sidemenu -->
 <div>
  <div class="d-flex justify-content-center pt-3">
    <router-link to="/" tag="a" class="navbar-brand mr-0 mr-md-2 logo">
      <span class="logo-lg">
        <img src="@assets/Logomark2000.png" alt height="45" />
        <span class="d-inline h5 ml-2 text-logo text-white">TALENT</span>
      </span>
    </router-link>
  </div>
  <ul id="side-menu" class="metismenu p-4 menu-custom">
    <li
      v-for="item in menuItems"
      :key="`item-${item.name}`"
      class="side-nav-item"
    >
      <p v-if="item.header" class="menu-title mb-0">{{ item.header }}</p>

      <a 
        v-if="hasItems(item)" 
        href="javascript:void(0);" 
        class="side-nav-link custom-nav-link d-flex align-items-center text-muted w-100 my-1 px-3 py-2"
        :class="{ 'active-link': $route.path.startsWith(`${item.path}`) }"
      >
        <feather v-if="item.icon" :type="item.icon" class="mr-2"></feather>
        <span>{{ $t(item.name.toLowerCase().replace(/ /g, '_') + ".plural") }}</span>
        <span class="menu-arrow"></span>
      </a>

      <router-link
        v-if="!hasItems(item)"
        tag="a"
        :to="`${item.path}`"
        class="side-nav-link side-nav-link-ref  d-flex align-items-center text-muted my-1 px-3 py-2"
         :class="{ 'active-link': $route.path.startsWith(`${item.path}`) }"
      >
        <feather v-if="item.icon" :type="item.icon" class="mr-2"></feather>
        <span>{{ $t(item.name.toLowerCase().replace(/ /g, '_') + ".plural") }}</span>
        <span
          v-if="item.badge"
          :class="
            'badge badge-' + item.badge.varient + ' float-right font-size-11'
          "
          >{{ item.badge.text }}</span
        >
      </router-link>

      <ul v-if="hasItems(item)" class="nav-second-level">
        <li
          v-for="subitem in getChildren(item.children)"
          :key="`sub-item-${subitem.name}`"
          :class="{ 'side-nav-item': hasItems(subitem) }"
        >
          <a
            v-if="hasItems(subitem)"
            href="javascript:void(0);"
            class="side-nav-link-a-ref"
          >
            {{ $t(subitem.name.toLowerCase().replace(/ /g, '_') + ".plural") }}
            <span class="menu-arrow"></span>
          </a>

          
          <router-link
            v-if="!hasItems(subitem)"
            tag="a"
            :to="`${item.path}/${subitem.path}`"
            class="side-nav-link-ref d-flex align-items-center  my-1 px-3 py-2 ml-3"
            :class="{ 'active-link': $route.path.startsWith(`${item.path}/${subitem.path}`) }"
          >
            <feather v-if="subitem.icon" :type="subitem.icon"  class="mr-2"></feather> {{ $t(subitem.name.toLowerCase().replace(/ /g, '_') + ".plural") }}
          </router-link>

          <ul
            v-if="hasItems(subitem)"
            class="nav-third-level"
            aria-expanded="false"
          >
            <li
              v-for="subSubitem in subitem.children"
              :key="`sub-sub-item-${subSubitem.name}`"
            >
              <router-link
                tag="a"
                :to="`${item.path}/${subitem.path}/${subSubitem.path}`"
                class="side-nav-link-ref"
                >{{ subSubitem.name }}</router-link
              >
            </li>
          </ul>
        </li>
      </ul>
    </li>
  </ul>
 </div>

  <!-- End Sidebar -->
</template>
<style lang="scss">
  .mm-active {
    .custom-nav-link {
      width: 188px;
    }
  }
  .side-nav-title{
    padding-top: 10px;
    padding-bottom: 10px
  }
  .active-link {
    color: #fff !important;
    background-color: #2a2a3c; // Customize this to your active bg color
    border-radius: 10px;
  }
  .menu-custom{
    height: 100vh;
    overflow-y: auto;
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
  }
  .menu-custom::-webkit-scrollbar {
    display: none;
  }
</style>
